import { useNavigate, useOutletContext } from 'react-router-dom';

import Alert from 'primitives/Alert';
import Button from 'primitives/Button';
import Select from 'primitives/Select';

import { formatCurrency, toTitleCase } from 'utils/format-helper';

const BasketsConfirmStep = () => {
  const {
    selectedDealDetails,
    perDealAllocations,
    investmentEntities,
    selectedInvestmentEntityId,
    setSelectedInvestmentEntityId,
    investmentAmount,
    transactionFee,
    totalCommitment,
    mutationError,
    creatingBasket,
    handleSubmitBasket,
  } = useOutletContext<any>();

  const navigate = useNavigate();

  return (
    <section className="space-y-6">
      <header className="space-y-2">
        <p className="text-sm text-gray-500">Confirm Your Investment</p>
        <h2 className="text-2xl font-semibold text-slate-900">Investment Split</h2>
      </header>
      <div className="rounded-3xl bg-white shadow-sm border border-slate-100">
        <div className="divide-y divide-slate-100">
          {selectedDealDetails.map((deal, index) => (
            <div key={deal.id} className="flex items-center justify-between px-6 py-4">
              <div>
                <p className="font-medium text-slate-900">{deal.companyInformation.company.name}</p>
                <p className="text-sm text-slate-500">
                  {deal.companyInformation.industries?.[0]
                    ? toTitleCase(deal.companyInformation.industries[0])
                    : 'Sector TBD'}
                </p>
              </div>
              <p className="text-base font-semibold text-slate-900">
                {formatCurrency(perDealAllocations[index] || 0)}
              </p>
            </div>
          ))}
        </div>
        <div className="border-t border-slate-100 px-6 py-4 space-y-4">
          <div>
            <Select
              label="Investment Entity"
              fullWidth
              value={selectedInvestmentEntityId}
              onChange={setSelectedInvestmentEntityId}
              options={investmentEntities.map(entity => ({
                value: entity.id,
                label: entity.name,
              }))}
            />
          </div>
          <div className="pt-6" />
          <dl className="space-y-2 text-sm">
            <div className="flex justify-between text-slate-600">
              <dt>Subtotal</dt>
              <dd>{formatCurrency(investmentAmount)}</dd>
            </div>
            <div className="flex justify-between text-slate-600">
              <dt>Transaction Cost (2%)</dt>
              <dd>{formatCurrency(transactionFee)}</dd>
            </div>
            <div className="flex justify-between text-base font-semibold text-slate-900">
              <dt>Total Amount</dt>
              <dd>{formatCurrency(totalCommitment)}</dd>
            </div>
          </dl>
          {mutationError && (
            <Alert
              type="error"
              title="Unable to confirm investment"
              message={mutationError.message}
            />
          )}
          <div className="flex gap-3 pt-2">
            <Button
              variant="secondary"
              className="flex-1 px-4 py-3"
              onClick={() => navigate('/invest/baskets')}
            >
              Back
            </Button>
            <Button
              variant="primary"
              className="flex-1 px-4 py-3 disabled:opacity-50"
              disabled={creatingBasket || !selectedInvestmentEntityId}
              loading={creatingBasket}
              onClick={handleSubmitBasket}
            >
              Invest
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BasketsConfirmStep;
